module.exports = __webpack_public_path__ + "img/symbol_0.c5635d04.png";